import { render } from "./indexAtributesComponent.vue?vue&type=template&id=2426a7dd&scoped=true"
import script from "./indexAtributesComponent.vue?vue&type=script&lang=js"
export * from "./indexAtributesComponent.vue?vue&type=script&lang=js"

import "./indexAtributesComponent.vue?vue&type=style&index=0&id=2426a7dd&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2426a7dd"]])

export default __exports__